import { Stack, styled, TextField } from '@mui/material';

export const StyledTextField = styled(TextField)`
  background-color: ${({ theme }) => theme.palette.common.white};
  border-radius: 13px;

  .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  .MuiInputBase-input {
    font-size: 14px; /* Updated to match sidebar */
    font-weight: 400;
    line-height: 1.43; /* Using the MUI body2 standard line height */
    letter-spacing: 0.4px;

    &:disabled {
      color: ${({ theme }) => theme.palette.text.primary};
      -webkit-text-fill-color: ${({ theme }) => theme.palette.text.primary};
    }
  }
`;

export const TitleAndButton = styled(Stack)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
  margin-bottom: 0 rem;
`;
